import { Link } from "react-router-dom";
import { Linkedin, MessageCircle, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-[#0E1B2E]/10 bg-[#0A1626] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo-eagle-white.png" alt="JS Aviation Group" className="h-10 w-auto shrink-0" />
              <div>
                <div className="font-serif text-lg">JS Aviation Group</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/60">Data driven aviation</div>
              </div>
            </div>
            <p className="mt-8 max-w-md text-white/70 leading-relaxed text-[15px]">
              Aviation advisory, asset trading, aircraft sourcing and transaction partner. Every recommendation supported by market intelligence, technical due diligence, and residual value analysis.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://wa.me/919999981766"
                target="_blank" rel="noreferrer"
                data-testid="footer-whatsapp-in"
                className="w-11 h-11 border border-white/15 hover:border-[#C8A97E] flex items-center justify-center transition-colors duration-300 relative group"
                aria-label="WhatsApp India"
              >
                <MessageCircle size={16} />
                <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 font-mono text-[9px] text-white/50 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">+91</span>
              </a>
              <a
                href="https://wa.me/447459103218"
                target="_blank" rel="noreferrer"
                data-testid="footer-whatsapp-uk"
                className="w-11 h-11 border border-white/15 hover:border-[#C8A97E] flex items-center justify-center transition-colors duration-300 relative group"
                aria-label="WhatsApp UK"
              >
                <MessageCircle size={16} />
                <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 font-mono text-[9px] text-white/50 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">+44</span>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank" rel="noreferrer"
                data-testid="footer-linkedin"
                className="w-11 h-11 border border-white/15 hover:border-[#C8A97E] flex items-center justify-center transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50 mb-6">Explore</div>
            <ul className="space-y-3 text-[14px]">
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/about" data-testid="footer-link-about">About</Link></li>
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/services" data-testid="footer-link-services">Services</Link></li>
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/aircraft" data-testid="footer-link-aircraft">Aircraft Listings</Link></li>
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/insights" data-testid="footer-link-insights">Market Insights</Link></li>
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/financing" data-testid="footer-link-financing">Financing</Link></li>
              <li><Link className="hover:text-[#C8A97E] transition-colors" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50 mb-6">Contact</div>
            <ul className="space-y-4 text-[14px] text-white/80">
              <li className="flex gap-3"><MapPin size={16} className="text-[#C8A97E] mt-0.5 shrink-0" />
                <span>Shams Business Centre,<br/> Sharjah Media City Free Zone,<br/> Al Messaned, Sharjah, UAE</span>
              </li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-[#C8A97E]" />
                <a href="tel:+919999981766" className="hover:text-white">+91 99999 81766</a>
                <span className="text-white/30">·</span>
                <a href="tel:+447459103218" className="hover:text-white">+44 7459 103218</a>
              </li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-[#C8A97E]" />
                <a href="mailto:info@jsgroupholdings.com" className="hover:text-white break-all">info@jsgroupholdings.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/50">
            © {new Date().getFullYear()} JS Aviation Group · All rights reserved
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/50 flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <Link to="/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
